/**
 * This module is useful when you need to create a reference to a view outside
 * of your current view's control, e.g. not a region in your layout.
 */

import Marionette from "backbone.marionette";

const DEFAULTS = {
  template: false,
};

class View extends Marionette.ItemView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }
}

export { View as default };
